import { fireErrorAnalytics } from '@atlassian/jira-errors-handling';
import { ff } from '@atlassian/jira-feature-flagging';
/**
 * This function will use functionTrue in dev mode.
 * If not, it will be controlled via the redux feature flag.
 * This is to enable the usage of stable selectors in dev mode for stability checks.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const functionWithFFRedux = <Fn extends (...args: any[]) => any>(
	functionTrue: Fn,
	functionFalse: Fn,
) => {
	// use stable selector in dev mode since stability checks are on in dev mode
	const isDevMode = process.env.NODE_ENV !== 'production';
	return ff('jff.magma.react-redux-upgrade_53sr4') || isDevMode ? functionTrue : functionFalse;
};

export const extractFactoryFunction = <Fn extends Function>(fn: Fn) => {
	if (!(fn && typeof fn === 'function' && fn.length === 0)) {
		return fn;
	}

	try {
		const result = fn();
		return typeof result === 'function' ? result : fn;
	} catch (e) {
		return fn;
	}
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mapStateToPropsWithErrorHandling = (mapStateToProps?: any) => {
	// return non-wrapped mapStateToProps if not a function
	if (!mapStateToProps) {
		return mapStateToProps;
	}
	if (typeof mapStateToProps !== 'function') {
		return mapStateToProps;
	}

	// return wrapped mapStateToProps which catches error, reports it and throws error again
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	return (...props: any) => {
		try {
			return mapStateToProps(...props);
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (e: any) {
			fireErrorAnalytics({
				meta: {
					id: 'mapStateToProps',
					packageName: 'jiraReactRedux',
					teamName: 'magma',
				},
				error: e,
			});
			throw e;
		}
	};
};
